'use client'

import cls from 'classnames'
import { useMemo, useState } from 'react'

import { casino, slots, spots } from '@/constants/bf'

export function GamesComponent() {
  // __STATE's
  const [currentTab, setCurrentTab] = useState<number>(0)
  const lists = useMemo(() => {
    return [
      {
        icon: '/static/images/icons/100-1.png',
        label: 'คาสิโน'
      },
      {
        icon: '/static/images/icons/100-2.png',
        label: 'สล็อด'
      },
      {
        icon: '/static/images/icons/100-3.png',
        label: 'กีฬา'
      },
      {
        icon: '/static/images/icons/100-4.png',
        label: 'หวย'
      }
    ].map((r, index) => ({
      ...r,
      active: index === currentTab
    }))
  }, [currentTab])

  const state = useMemo(() => {
    switch (currentTab) {
      case 0:
        return casino

      case 1:
        return slots

      case 2:
        return spots

      default:
        return [{ image: '/static/images/games/bf/01.png', name: 'Pretty Gaming' }]
    }
  }, [currentTab])

  // __RENDER
  return (
    <div className='ui--home-games'>
      <div className='container rounded-2xl bg-black p-4'>
        <div className='tabs grid grid-flow-col justify-around gap-4'>
          {lists.map((record, index) => (
            <button
              className={cls('btn btn-tab', { active: record.active })}
              type='button'
              key={index}
              onClick={() => setCurrentTab(index)}>
              <div className='icon'>
                <img className='size-8' src={record.icon} />
              </div>

              <p className='text'>{record.label}</p>
            </button>
          ))}
        </div>

        <div className='mt-8 grid grid-cols-4 gap-4 max-md:grid-cols-3 max-sm:grid-cols-2'>
          {state.map((record, index) => (
            <div className='' key={index}>
              <img className='w-full object-contain object-center' src={record.image} />
              <p className='py-1 text-center text-sm capitalize'>{record.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
